import { render } from "./DashboardSpaceOverview.vue?vue&type=template&id=b84298ac"
import script from "./DashboardSpaceOverview.vue?vue&type=script&lang=js"
export * from "./DashboardSpaceOverview.vue?vue&type=script&lang=js"
script.render = render

export default script